import './CSS_ke_log/CssForFIVEJS.css'
const Four = () => {
    return (
        <div className="csskabaap" id="pncilwala">
         <p>वायरस रेडियो तरंगों/मोबाइल नेटवर्क पर यात्रा नहीं कर सकते। COVID-19 कई देशों में फैल रहा है जिनके पास 5G मोबाइल नेटवर्क नहीं है।

COVID-19 एक संक्रमित व्यक्ति के खांसने, छींकने या बोलने पर सांस की बूंदों से फैलता है। लोग दूषित सतह और फिर उनकी आंख, मुंह या नाक को छूने से भी संक्रमित हो सकते हैं।</p>
        </div>
    )
};

export default Four;